import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from 'app/redux/store';

import {
  EducationalInstitutionActivatedCodeResponse,
  EducationalInstitutionStudentDetailResponse,
  EducationalInstitutionTryActivateCodeResponse,
  EducationalState,
} from '../types';
import { EducationalInstitutionRecoverUserByActivationCodeResponse } from '../types/EducationalInstitutionRecoverUserByActivationCodeResponse';

const initialState: EducationalState = {
  activateCode: undefined!,
  activationCode: '',
  activatedCode: undefined!,
  recoveryUser: undefined!,
  studentDetail: undefined!,
};

const educationalSlice = createSlice({
  name: 'educational',
  initialState,
  reducers: {
    setActivateCodeAction(
      state,
      action: PayloadAction<{
        activateCode: EducationalInstitutionTryActivateCodeResponse;
        activationCode: string;
      }>
    ) {
      const { activateCode, activationCode } = action.payload;

      state.activationCode = activationCode;
      state.activateCode = activateCode;
    },

    clearActivateCodeAction(state) {
      state.activationCode = '';
      state.activateCode = undefined!;
    },

    setActivatedCodeAction(state, action: PayloadAction<EducationalInstitutionActivatedCodeResponse>) {
      state.activatedCode = action.payload;
    },

    clearActivatedCodeAction(state) {
      state.activatedCode = undefined!;
    },

    setRecoveryUserAction(state, action: PayloadAction<EducationalInstitutionRecoverUserByActivationCodeResponse>) {
      state.recoveryUser = action.payload;
    },

    clearRecoveryUserAction(state) {
      state.recoveryUser = undefined!;
    },

    setStudentDetailAction(state, action: PayloadAction<EducationalInstitutionStudentDetailResponse>) {
      state.studentDetail = action.payload;
    },

    clearStudentDetailAction(state) {
      state.recoveryUser = undefined!;
    },
  },
});

export const {
  setActivateCodeAction,
  clearActivateCodeAction,
  setActivatedCodeAction,
  clearActivatedCodeAction,
  setRecoveryUserAction,
  clearRecoveryUserAction,
  setStudentDetailAction,
  clearStudentDetailAction,
} = educationalSlice.actions;

export const getEducational = (state: RootState): EducationalState => state.educational;

export default educationalSlice.reducer;
